// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"847":"f53c36c2","2544":"0fdd52dd","2830":"f53c36c2","5551":"f0184267","6802":"fc87d9c6"}[chunkId] + ".chunk.css";
};